import {Component} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
  imports: [
    ModalContainerComponent,
    NgOptimizedImage
  ]
})
export class ImageModalComponent {
  title: string;
  imgSrc: string;

}
